module.exports = __webpack_public_path__ + "img/tag_elite@3x.png";